import {http} from '@/services/http'
import type {PetFormData} from '@/services/pet-profiles/models'
import type {Pet} from '@/models/consumer-engagement-models'
import type {Result} from '@/utilities/types'

export const updatePetProfile = async (
	updatedPetData: PetFormData,
	locale: string
): Promise<Pet> => {
	const {data} = await http<Result<Pet>>(
		`/api/pets/${updatedPetData.id}?locale=${locale}`,
		{
			method: 'PUT',
			data: {
				name: updatedPetData.petName,
				gender: updatedPetData.petSex,
				breed: updatedPetData.breed,
				species: updatedPetData.petSpecies,
				birthDate: updatedPetData.petDateOfBirth,
				weight: Number(updatedPetData.petWeight),
				acquisitionSource: updatedPetData.petAcquisitionType,
				acquisitionDate: updatedPetData.petAcquisitionDate,
				petShelterId: updatedPetData.petShelter,
				petShelterName: updatedPetData.shelterName,
				vetClinicId: updatedPetData.vetClinic,
				vetClinicName: updatedPetData.clinicName,
				imageReference: updatedPetData.imageReference,
			},
		}
	)
	if (!data.success) {
		throw new Error('Failed to update pet profile')
	}

	return data.data
}
